import styled from 'styled-components'

import { StyleProps } from './types'

export default styled.div<StyleProps>`
  margin-top: ${(props): string => (props.isSpaced ? '40px' : '20px')};
  margin-bottom: ${(props): string => (props.isSpaced ? '40px' : '20px')};
  margin-left: ${(props): string => (props.isCentered ? 'auto' : '0')};
  margin-right: ${(props): string => (props.isCentered ? 'auto' : '0')};
  max-width: 460px;
  width: 100%;
  &:last-of-type {
    margin-top: ${(props): string => (props.isSpaced ? '40px' : '0')};
    margin-bottom: ${(props): string => (props.isSpaced ? '40px' : '0')};
  }
`
